export default function setProductTabs() {
  const sections = document.querySelectorAll('.product-description');

  sections.forEach((section) => {
    const items = section.querySelectorAll('.accordion-item');

    items.forEach((item) => {
      const button = item.querySelector('.titulo');
      const content = item.querySelector('.content');

      button.addEventListener('click', () => {
        const isActive = button.classList.contains('-active');

        // fecha todos (caso queira apenas um aberto)
        items.forEach((i) => {
          i.querySelector('.titulo').classList.remove('-active');
          i.querySelector('.content').classList.remove('-active');
        });

        if (!isActive) {
          button.classList.add('-active');
          content.classList.add('-active');
        }
      });
    });
  });
}